
type Props = {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  className?: string;
};

export function Loading({ size = 'md', fullScreen = false, className = '' }: Props) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const containerClass = fullScreen
    ? 'fixed inset-0 flex items-center justify-center bg-white/80 z-50'
    : 'flex items-center justify-center';

  return (
    <div className={`${containerClass} ${className}`}>
      <div
        className={`${sizeClasses[size]} border-t-2 border-blue-600 border-solid rounded-full animate-spin`}
      ></div>
    </div>
  );
}
